import React, { useEffect, useState ,useRef} from 'react';
import AxiosInstance from '../AxiosInstance';
import ProfileModal from './ProfileModal'; 
import ELayout from'./ELayout';
import moment from "moment";
import ToastNotification from '../ToastNotification';

const Profile = () => {
  const userId = localStorage.getItem('employeeId');
  const [userData, setUserData] = useState(null);
  const [activeTab, setActiveTab] = useState('personal_info');
  const [showModal, setShowModal] = useState(false); 
  const [imageFile, setImageFile] = useState(null); 
  const [imagePreview, setImagePreview] = useState(''); 
  const imageUrl = process.env.REACT_APP_BASE_URL+'/uploads/';
  const toastRef = useRef(null);

  useEffect(() => {
    AxiosInstance
      .get(`/common/api/user-details/${userId}`)
      .then((response) => {
        setUserData(response.data);
      })
      .catch((error) => {
         toastRef.current?.showToast('Error fetching user data:', "danger");
      });
  }, [userId]);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImageFile(file);
      setImagePreview(URL.createObjectURL(file)); 
    }
  };


  const handleSaveImage = () => {
    if (imageFile) {
      const formData = new FormData();
      formData.append('userId', userId);
      formData.append('image', imageFile);
  
      AxiosInstance
        .post(`/employee/upload-image/${userId}`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then((response) => {
          const imageName = response.data.imageName; 
  
          AxiosInstance
            .get(`/employee/check-user-details/${userId}`) 
            .then((checkResponse) => {
              const userDetailsExist = checkResponse.data.exists;
  
              if (userDetailsExist) {
                AxiosInstance
                  .put(`/employee/update-user-image/${userId}`, {
                    userId,
                    image_profile: imageName,
                  })
                  .then(() => {
                    setUserData((prevData) => ({
                      ...prevData,
                      image_profile: imageName,
                    }));
                  })
                  .catch((error) => {
                    toastRef.current?.showToast('Error updating user details:',"danger");
                  });
              } else {
                AxiosInstance
                  .post(`/employee/insert-user-image/${userId}`, {
                    userId: userId,
                    image_profile: imageName,
                  })
                  .then(() => {
                    setUserData((prevData) => ({
                      ...prevData,
                      image_profile: imageName,
                    }));
                  })
                  .catch((error) => {
                    toastRef.current?.showToast('Error inserting user details:',"danger");
                  });
              }
            })
            .catch((error) => {
               toastRef.current?.showToast('Error checking user details:', "danger");
            });
  
          setImageFile(null);
          setImagePreview('');
        })
        .catch((error) => {
          toastRef.current?.showToast('Error uploading image:',"danger");
        });
    }
  };
  
  const handleCancelImage = () => {
    setImageFile(null);
    setImagePreview('');
  };



  if (!userData) {
    return (
      <ELayout>
    <div>Loading...</div>;
    </ELayout>
    );
  }

  const {
    username,
    first_name,
    middle_name,
    last_name,
    manager_first_name,
    manager_middle_name,
    manager_last_name,
    image_profile,
    date_of_birth,
    date_of_join,
    address,
    gender,
    employee_code,
    department_name,
    designation_name,

    education,
    about,
    email,
    phone_number,
    social_media_links,
    emergency_contact,
  } = userData;

 const formatDate = (date) => {
    return date !== 'Not provided' ? moment(date).format('MM-DD-YYYY') : date;
  };
  
  const handleOpenModal = () => {
    setShowModal(true);  
  };

  const handleCloseModal = () => {
    setShowModal(false);  
  };

  return (
    <ELayout heading="Profile">
    <div className="container">
    <div className="d-flex justify-content-end mb-2">
    <button className="btn btn-secondary" onClick={() => handleOpenModal()}>
      <i className="bi bi-pencil-fill"></i> Update Details
    </button>
    </div>
  <div className="row p-4" style={{ backgroundColor: "#f0f0f0", borderRadius: "8px" }}>
    <div className="col-md-4 col-sm-12 d-flex justify-content-center mb-3 mb-md-0">
      <div
        style={{
          width: "150px",
          height: "150px",
          borderRadius: "50%",
          overflow: "hidden",
          backgroundColor: "#ccc",
          position: "relative",
        }}
      >
        <img
          src={imagePreview || (image_profile ? `${imageUrl + image_profile}` : "path/to/default.jpg")}
          alt="Profile"
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
        />
        <label
          htmlFor="image-upload"
          style={{
            position: "absolute",
            bottom: "-10px",
            left: "50%",
            transform: "translateX(-50%)",
            background: "rgba(0, 0, 0, 0.5)",
            color: "white",
            borderRadius: "50%",
            padding: "10px",
            cursor: "pointer",
          }}
        >
          <i className="bi bi-camera"></i>
        </label>
        <input type="file" id="image-upload" style={{ display: "none" }} onChange={handleImageChange} />
      </div>
    </div>

    <div className="col-md-8 col-sm-12 text-center text-md-start">
    <h4 style={{ textTransform: "capitalize" }}>
      {`${first_name} ${middle_name && middle_name !== "null" ? middle_name + " " : ""}${last_name}`}
    </h4>
      <p>User ID: {userId}</p>
      <p>Username: {username}</p>
      <p>Employee Code: {employee_code || 'Not provided'}</p>
      <p style={{ textTransform: "capitalize" }}>
        Manager: {`${manager_first_name} ${manager_middle_name && manager_middle_name !== "null" ? manager_middle_name + " " : ""}${manager_last_name}`}
      </p>
    </div>
  </div>

  {imageFile && (
    <div className="d-flex justify-content-center mt-3">
      <button className="btn btn-success me-2" onClick={handleSaveImage}>
        Save
      </button>
      <button className="btn btn-danger" onClick={handleCancelImage}>
        Cancel
      </button>
    </div>
  )}

    <div className="card mt-4">
      <div className="card-header" style={{ backgroundColor: '#343a40', color: '#fff' }}>
        Details
      </div>
        <div className="card-body">
          <ul className="nav nav-tabs d-flex flex-wrap justify-content-between w-100">
            <li className="nav-item flex-fill text-center">
              <button
                className={`nav-link ${activeTab === 'personal_info' ? 'active bg-secondary text-white' : ''}`}
                style={{ color: '#6c757d', width: '100%', fontSize: '13px', padding: '6px' }}
                onClick={() => setActiveTab('personal_info')}
              >
                Personal Info
              </button>
            </li>

            <li className="nav-item flex-fill text-center">
              <button
                className={`nav-link ${activeTab === 'education' ? 'active bg-secondary text-white' : ''}`}
                style={{ color: '#6c757d', width: '100%', fontSize: '13px', padding: '6px' }}
                onClick={() => setActiveTab('education')}
              >
                Education
              </button>
            </li>

            <li className="nav-item flex-fill text-center">
              <button
                className={`nav-link ${activeTab === 'contact_info' ? 'active bg-secondary text-white' : ''}`}
                style={{ color: '#6c757d', width: '100%', fontSize: '13px', padding: '6px' }}
                onClick={() => setActiveTab('contact_info')}
              >
                Contact Info
              </button>
            </li>
          </ul>

            <div className="mt-3">
              {activeTab === 'personal_info' && (
                <div style={{ textTransform: 'capitalize' }}>
                  <p><strong>Name:</strong> {`${first_name} ${middle_name && middle_name !== "null" ? middle_name + " " : ""}${last_name}`}</p>
                  <p><strong>Gender:</strong> {gender !== 'Not provided' ? gender : 'Not provided'}</p>
                  <p><strong>Date of Birth:</strong> {formatDate(date_of_birth)}</p>
                  <p><strong>Address:</strong> {address !== 'Not provided' ? address : 'Not provided'}</p>
                  <p><strong>Department:</strong> {department_name !== 'Not provided' ? department_name : 'Not provided'}</p>
                  <p><strong>Designation:</strong> {designation_name || 'Not provided'}</p>
                  <p><strong>Date of Joining:</strong> {formatDate(date_of_join)}</p>
                  <div 
                    style={{ 
                      backgroundColor: '#f8d7da', 
                      color: 'black', 
                      padding: '10px',
                      borderRadius: '5px',
                      marginTop: '10px'
                    }}
                  >
                    <strong>Emergency Contact:</strong> {emergency_contact && emergency_contact !== 'Not provided' ? emergency_contact : 'Not provided'}
                  </div>
                </div>
              )}
              {activeTab === 'education' && (
                <div>
                  <p><strong>Education:</strong></p>
                  <ul>
                    {education
                      ? (typeof education === 'string' && education !== 'Not provided'
                          ? JSON.parse(education).map((edu, index) => (
                              <li key={index}>
                                <p><strong>Course Name:</strong> {edu.degree}</p>
                                <p><strong>Institute:</strong> {edu.institute}</p>
                                <p><strong>Year:</strong> {edu.year}</p>
                              </li>
                            ))
                          : <li>Not provided</li>)
                      : <li>Not provided</li>}
                  </ul>
                  <p><strong>About:</strong> {about || 'Not provided'}</p>
                </div>
              )}
              {activeTab === 'contact_info' && (
                <div>
                  <p><strong>Email:</strong> {email || 'Not provided'}</p>
                  <p><strong>Phone Number:</strong> {phone_number || 'Not provided'}</p>
                  <p><strong>Social Media Links:</strong></p>
                  <ul>
                    {social_media_links
                      ? (typeof social_media_links === 'string' && social_media_links !== 'Not provided'
                          ? JSON.parse(social_media_links).map((link, index) => (
                              <li key={index}>
                                <a href={link.url} target="_blank" rel="noopener noreferrer">
                                  {link.platform}
                                </a>
                              </li>
                            ))
                          : <li>Not provided</li>)
                      : <li>Not provided</li>}
                  </ul>
                </div>
              )}
            </div>
          </div>
        </div>
        <ToastNotification ref={toastRef} />
      </div>
      <ProfileModal
        showModal={showModal}
        handleClose={handleCloseModal}
        userData={userData} 
      />
    </ELayout>
  );
};

export default Profile;
